import { render, staticRenderFns } from "./asset-type.vue?vue&type=template&id=017142b9&"
import script from "./asset-type.vue?vue&type=script&lang=js&"
export * from "./asset-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports